<template>
  <div>
    <span>
      <a
        data-container="body"
        data-html="true"
        data-toggle="popover"
        type="button"
        href="#"
        :style="`color:${color};`"
        @click.prevent
        :data-placement="placement"
      >
        <span v-if="boldText">
          <b>{{ label }}</b>
        </span>
        <span v-else="">
          {{ label }}
        </span>
      </a>
      <div v-show="false">
        <div class="content">
          <slot></slot>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'popover',
  props: ['label', 'title', 'placement', 'trigger', 'color', 'boldText'],
  mounted() {
    this.$nextTick(() => {
      let content = this.$el.querySelector('.content').innerHTML
      window.$(this.$el.querySelector('[data-toggle=popover]')).popover({
        title: this.title,
        trigger: this.trigger,
        html: true,
        content: () => content
      })
    })
  }
}
</script>

<style scoped="">
.popover {
  max-width: 500px !important;
}
</style>
